module.exports = __webpack_public_path__ + "static/media/twitter.c8b08309.svg";